/**
 * custom-product-options.js
 * -----------------------------------------------------------------
 * Reemplazo casero de Easify.
 *
 * Qué hace:
 *  1. Calcula el precio en vivo sumando los recargos de las opciones
 *     seleccionadas (incluyendo el selector de "cantidad de
 *     mascotas", si el producto lo usa) al precio base de la variante.
 *  2. Al hacer "Agregar al carrito":
 *     a) Agrega el producto principal (con la imagen que subió el
 *        cliente, si aplica, como propiedad de archivo nativa de Shopify;
 *        incluye una foto por cada "bloque de mascota" visible).
 *     b) Si hay recargo de precio, agrega una segunda línea al carrito
 *        usando un "producto de recargo" (ver README.md) para que el
 *        total del carrito refleje el precio correcto — esto es
 *        necesario porque una tienda sin Shopify Plus no puede cambiar
 *        el precio de una línea del carrito de forma arbitraria.
 *
 * CONFIGURACIÓN OBLIGATORIA:
 *  Completa el mapa ADDON_VARIANT_MAP más abajo con los IDs de variante
 *  del producto "Cargo adicional" que crees en tu tienda (ver README.md,
 *  paso 3). La clave es el monto en tu moneda (mismo número que usas en
 *  el JSON de opciones, ej. 150 para $150.00) y el valor es el ID de la
 *  variante correspondiente.
 */

(function () {
  'use strict';

  // ------------------------------------------------------------------
  // 1) CONFIGURA AQUÍ los IDs de variante de tu producto "Cargo adicional"
  //    Ejemplo: si creaste variantes de $25, $50, $100, $150, $200 y sus
  //    IDs de variante son los que Shopify te dio, se vería así:
  //
  //    var ADDON_VARIANT_MAP = {
  //      25: 41234567890123,
  //      50: 41234567890124,
  //      100: 41234567890125,
  //      150: 41234567890126,
  //      200: 41234567890127
  //    };
  // ------------------------------------------------------------------
  var ADDON_VARIANT_MAP = {
    25: 52810860167455,
    50: 52810860200223,
    80: 52810860232991,
    100: 52810860265759,
    150: 52810860298527,
    200: 52810860331295,
    250: 52810860364063,
    300: 52810860396831,
    375: 52810870325535,
    // Recargos por cantidad de mascotas (bordados: +$475 c/u, ilustrados: +$375 c/u)
    // y combinaciones con el recargo de "incluir humano" (+$375) en ilustrados.
    475: 52810887332127,
    750: 52810887364895,
    950: 52810887397663,
    1125: 52810887430431,
    1425: 52810887463199,
    1500: 52810887495967,
    1875: 52810887528735,
    1900: 52810887561503,
    2250: 52810887594271,
    2375: 52810887627039,
    // Recargos por mascotas de los kits "marco floral de diseñador" (+$200 c/u)
    // y combinaciones con el recargo de "incluir humano" (+$375).
    400: 52811793662239,
    575: 52811793695007,
    600: 52811793727775,
    775: 52811793760543,
    800: 52811793793311,
    975: 52811793826079,
    1000: 52811793858847,
    1175: 52811793891615,
    1375: 52811793924383,
    570: 52974936686879,
    945: 52974936719647,
    // Segunda ronda de recargos faltantes para otras líneas de productos
    // personalizados (mismo bug: montos sin entrada en este mapa).
    255: 52975093219615,
    510: 52975093252383,
    765: 52975093285151,
    1020: 52975093317919,
    625: 52842151641375,
    730: 52842151674143,
    1250: 52842151706911,
    1275: 52848305045791,
    1460: 52842151739679,
    2190: 52842151772447,
    2920: 52842151837983,
    3125: 52842151870751,
    3650: 52842151903519,
    // Tercera ronda de recargos faltantes: tiers k=2..5 de mascotas extra
    // (hasta 6 mascotas en total) de la línea de $570/mascota, con y sin el
    // checkbox de "incluir humano" (+$375), y el tier k=4 faltante de la
    // línea de $625/mascota.
    1140: 52975202533663,
    1710: 52975202566431,
    2280: 52975202599199,
    2850: 52975202631967,
    1515: 52975202664735,
    2085: 52975202697503,
    2655: 52975202730271,
    3225: 52975202763039,
    2500: 52842151805215
  };

  // Qué hacer después de agregar al carrito: 'redirect' | 'reload' | 'none'
  var AFTER_ADD_BEHAVIOR = 'redirect';

  // ------------------------------------------------------------------
  // Formatea un monto (en unidades de moneda, ej. pesos, NO centavos)
  // usando el mismo formato configurado en la tienda (Ajustes > Formato
  // de moneda en el admin de Shopify), para que coincida exactamente con
  // el precio que ya muestra el tema arriba. Si por alguna razón no
  // tenemos ese formato a la mano, cae de regreso a "$1,234.00".
  // ------------------------------------------------------------------
  function formatWithDelimiters(amount, precision, thousands, decimal) {
    precision = typeof precision === 'undefined' ? 2 : precision;
    thousands = typeof thousands === 'undefined' ? ',' : thousands;
    decimal = typeof decimal === 'undefined' ? '.' : decimal;
    if (isNaN(amount) || amount === null) return '0';
    var fixed = Math.abs(amount).toFixed(precision);
    var parts = fixed.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';
    return (amount < 0 ? '-' : '') + dollars + cents;
  }

  function formatMoney(amount, moneyFormat) {
    try {
      var format = moneyFormat || '${{amount}}';
      var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
      if (!match) return '$' + amount.toFixed(2);
      var value;
      switch (match[1]) {
        case 'amount_no_decimals':
          value = formatWithDelimiters(amount, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(amount, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(amount, 0, '.', ',');
          break;
        default:
          value = formatWithDelimiters(amount, 2);
      }
      return format.replace(match[0], value);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function getGroupSurcharge(wrapper) {
    var total = 0;
    var inputs = wrapper.querySelectorAll('[data-option-input]');
    inputs.forEach(function (input) {
      var type = input.getAttribute('data-price-type');
      var price = parseFloat(input.getAttribute('data-price') || '0') || 0;

      if (type === 'select') {
        var selected = input.options[input.selectedIndex];
        var p = selected ? parseFloat(selected.getAttribute('data-price') || '0') || 0 : 0;
        total += p;
      } else if (type === 'radio') {
        if (input.checked) total += price;
      } else if (type === 'checkbox') {
        if (input.checked) total += price;
      } else if (type === 'text' || type === 'textarea') {
        if (input.value.trim() !== '') total += price;
      }
    });
    return total;
  }

  function getPetQuantitySurcharge(wrapper) {
    var group = wrapper.querySelector('[data-pet-quantity]');
    if (!group) return 0;
    var sel = group.querySelector('[data-pet-qty-select]');
    if (!sel) return 0;
    var pricePerExtra = parseFloat(group.getAttribute('data-pet-price') || '0') || 0;
    var qty = parseInt(sel.value, 10) || 1;
    var extra = qty - 1;
    if (extra < 0) extra = 0;
    return extra * pricePerExtra;
  }

  function getTotalSurcharge(wrapper) {
    return getGroupSurcharge(wrapper) + getPetQuantitySurcharge(wrapper);
  }

  // ------------------------------------------------------------------
  // En vez de mostrar un segundo precio aparte ("Precio con opciones"),
  // actualizamos DIRECTAMENTE el precio que el tema ya muestra arriba
  // (el bloque nativo de Dawn), para que el cliente vea un solo número
  // que sube conforme agrega mascotas u otras opciones con costo.
  // ------------------------------------------------------------------
  function updateNativePriceDisplay(wrapper, total) {
    var host = wrapper.closest('product-info');
    if (!host) return;
    var priceBlock = host.querySelector('.price');
    if (!priceBlock) return;
    var moneyFormat = wrapper.getAttribute('data-money-format');
    var formatted = formatMoney(total, moneyFormat);

    var regular = priceBlock.querySelector('.price__regular .price-item--regular');
    var sale = priceBlock.querySelector('.price__sale .price-item--sale');
    if (regular) regular.textContent = formatted;
    if (sale) sale.textContent = formatted;
  }

  function updatePriceDisplay(wrapper) {
    var basePrice = parseFloat(wrapper.getAttribute('data-base-price')) || 0;
    var surcharge = getTotalSurcharge(wrapper);
    var total = basePrice + surcharge;
    wrapper.setAttribute('data-current-surcharge', surcharge);
    updateNativePriceDisplay(wrapper, total);
  }

  function setupImagePreview(wrapper) {
    var fileInput = wrapper.querySelector('[data-option-image]');
    if (!fileInput) return;
    var previewWrap = wrapper.querySelector('[data-image-preview]');
    var previewImg = wrapper.querySelector('[data-image-preview-img]');

    fileInput.addEventListener('change', function () {
      var file = fileInput.files && fileInput.files[0];
      if (!file) {
        if (previewWrap) previewWrap.hidden = true;
        return;
      }
      // Límite de tamaño sugerido: 10 MB (ajústalo si tu servidor Shopify lo permite mayor)
      var maxBytes = 10 * 1024 * 1024;
      if (file.size > maxBytes) {
        alert('La imagen es muy grande. El límite es 10 MB.');
        fileInput.value = '';
        if (previewWrap) previewWrap.hidden = true;
        return;
      }
      var reader = new FileReader();
      reader.onload = function (e) {
        if (previewImg) previewImg.src = e.target.result;
        if (previewWrap) previewWrap.hidden = false;
      };
      reader.readAsDataURL(file);
    });
  }

  // ------------------------------------------------------------------
  // Subida de UNA sola foto como su propio grupo (tipo "photo_upload"),
  // independiente del selector de cantidad de mascotas y del "image_upload"
  // general del producto. Puede haber varios grupos de este tipo en un
  // mismo producto, así que se procesan todos por separado.
  // ------------------------------------------------------------------
  function setupGroupPhotoUpload(wrapper) {
    var inputs = wrapper.querySelectorAll('[data-group-photo-input]');
    inputs.forEach(function (input) {
      var group = input.closest('[data-option-group]');
      var previewWrap = group ? group.querySelector('[data-group-photo-preview]') : null;
      var previewImg = group ? group.querySelector('[data-group-photo-preview-img]') : null;

      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        if (!file) {
          if (previewWrap) previewWrap.hidden = true;
          return;
        }
        var maxBytes = 10 * 1024 * 1024;
        if (file.size > maxBytes) {
          alert('La imagen es muy grande. El límite es 10 MB.');
          input.value = '';
          if (previewWrap) previewWrap.hidden = true;
          return;
        }
        var reader = new FileReader();
        reader.onload = function (e) {
          if (previewImg) previewImg.src = e.target.result;
          if (previewWrap) previewWrap.hidden = false;
        };
        reader.readAsDataURL(file);
      });
    });
  }

  // ------------------------------------------------------------------
  // Subida de VARIAS fotos en un solo campo (ej. "Sube tus 8 fotos
  // favoritas"). Valida el máximo de archivos y de tamaño, y muestra
  // una miniatura por cada foto seleccionada.
  // ------------------------------------------------------------------
  function setupMultiPhotoUpload(wrapper) {
    var inputs = wrapper.querySelectorAll('[data-multi-photo-input]');
    inputs.forEach(function (input) {
      var maxFiles = parseInt(input.getAttribute('data-max-files'), 10) || 8;
      var group = input.closest('[data-option-group]');
      var previewWrap = group ? group.querySelector('[data-multi-photo-preview]') : null;

      input.addEventListener('change', function () {
        var files = Array.prototype.slice.call(input.files || []);

        if (files.length > maxFiles) {
          alert('Puedes subir un máximo de ' + maxFiles + ' fotos.');
          input.value = '';
          if (previewWrap) {
            previewWrap.innerHTML = '';
            previewWrap.hidden = true;
          }
          return;
        }

        var maxBytes = 10 * 1024 * 1024;
        for (var i = 0; i < files.length; i++) {
          if (files[i].size > maxBytes) {
            alert('Una de las imágenes es muy grande. El límite es 10 MB por foto.');
            input.value = '';
            if (previewWrap) {
              previewWrap.innerHTML = '';
              previewWrap.hidden = true;
            }
            return;
          }
        }

        if (!previewWrap) return;
        previewWrap.innerHTML = '';
        if (files.length === 0) {
          previewWrap.hidden = true;
          return;
        }
        previewWrap.hidden = false;
        files.forEach(function (file) {
          var reader = new FileReader();
          reader.onload = function (e) {
            var img = document.createElement('img');
            img.src = e.target.result;
            img.alt = 'Vista previa';
            previewWrap.appendChild(img);
          };
          reader.readAsDataURL(file);
        });
      });
    });
  }

  // ------------------------------------------------------------------
  // "Cantidad de mascotas": muestra/oculta los bloques de Mascota 2, 3, ...
  // según lo que elija el cliente, y marca como requeridos/deshabilitados
  // solo los campos que están visibles (para que no se suban ni se
  // exijan datos de mascotas que no aplican).
  // ------------------------------------------------------------------
  function updatePetBlocks(wrapper) {
    var group = wrapper.querySelector('[data-pet-quantity]');
    if (!group) return;
    var sel = group.querySelector('[data-pet-qty-select]');
    var qty = parseInt(sel.value, 10) || 1;
    var nameRequired = group.getAttribute('data-pet-name-required') !== 'false';
    var photoRequired = group.getAttribute('data-pet-photo-required') !== 'false';

    var blocks = group.querySelectorAll('[data-pet-block]');
    blocks.forEach(function (block) {
      var idx = parseInt(block.getAttribute('data-pet-index'), 10) || 1;
      var visible = idx <= qty;
      block.hidden = !visible;

      var fields = block.querySelectorAll('[data-pet-field]');
      fields.forEach(function (field) {
        field.disabled = !visible;
        if (!visible) {
          field.required = false;
          return;
        }
        if (field.hasAttribute('data-pet-name')) {
          field.required = nameRequired;
        } else if (field.hasAttribute('data-pet-photo')) {
          field.required = photoRequired;
        }
      });
    });
  }

  function setupPetQuantity(wrapper) {
    var group = wrapper.querySelector('[data-pet-quantity]');
    if (!group) return;
    var sel = group.querySelector('[data-pet-qty-select]');
    if (!sel) return;

    updatePetBlocks(wrapper);

    sel.addEventListener('change', function () {
      updatePetBlocks(wrapper);
      updatePriceDisplay(wrapper);
    });

    // Botones tipo "pill" que reflejan y controlan el <select> oculto
    // (así toda la lógica de precio/mascotas sigue funcionando igual).
    var pills = group.querySelectorAll('[data-pet-qty-pill]');
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) {
          p.classList.remove('is-selected');
          p.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('is-selected');
        pill.setAttribute('aria-pressed', 'true');
        sel.value = pill.getAttribute('data-value');
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    setupPetPhotoUploads(group);
  }

  // ------------------------------------------------------------------
  // Fotos de mascota (hasta 2 por mascota): el input visible ("puerta
  // de entrada") nunca guarda archivos — cada foto que el cliente elige
  // se reparte de inmediato en uno de los 2 campos reales que sí se
  // envían con el pedido (Mascota N - Foto 1 / Foto 2), usando
  // DataTransfer para asignarle un archivo a un <input type="file">
  // por código. El botón de seleccionar se oculta solo cuando las 2
  // ya están ocupadas, y cada miniatura trae su propia "✕" para
  // borrar esa foto y liberar el espacio de nuevo.
  // ------------------------------------------------------------------
  function setupPetPhotoUploads(group) {
    var blocks = group.querySelectorAll('[data-pet-block]');
    var maxBytes = 10 * 1024 * 1024;

    blocks.forEach(function (block) {
      var picker = block.querySelector('[data-pet-photo-picker]');
      if (!picker) return;

      var dropzone = block.querySelector('[data-pet-photo-dropzone]');
      var dropzoneLabel = block.querySelector('[data-pet-photo-dropzone-label]');
      var slots = Array.prototype.slice.call(block.querySelectorAll('[data-pet-photo-slot]'));
      var realInputs = Array.prototype.slice.call(block.querySelectorAll('[data-pet-photo-real]'));

      function firstEmptySlotIndex() {
        for (var i = 0; i < realInputs.length; i++) {
          if (!realInputs[i].files || realInputs[i].files.length === 0) return i;
        }
        return -1;
      }

      function refreshDropzoneVisibility() {
        if (!dropzone) return;
        var emptyIndex = firstEmptySlotIndex();
        if (emptyIndex === -1) {
          dropzone.hidden = true;
          return;
        }
        dropzone.hidden = false;
        var isFirstPhoto = emptyIndex === 0;
        dropzone.classList.toggle('custom-options__dropzone--add-more', !isFirstPhoto);
        if (dropzoneLabel) {
          dropzoneLabel.textContent = isFirstPhoto ? 'Seleccionar tus fotografías' : 'Agregar otra foto';
        }
      }

      function setSlotFile(index, file) {
        var realInput = realInputs[index];
        var slot = slots[index];
        if (!realInput || !slot) return;
        var img = slot.querySelector('[data-pet-photo-slot-img]');

        if (file) {
          var dt = new DataTransfer();
          dt.items.add(file);
          realInput.files = dt.files;

          var reader = new FileReader();
          reader.onload = function (e) {
            if (img) img.src = e.target.result;
          };
          reader.readAsDataURL(file);
          slot.hidden = false;
        } else {
          realInput.value = '';
          if (img) img.src = '';
          slot.hidden = true;
        }
        refreshDropzoneVisibility();
      }

      picker.addEventListener('change', function () {
        var files = Array.prototype.slice.call(picker.files || []);
        // La puerta de entrada nunca se queda con los archivos: se
        // vacía de inmediato apenas se reparten a los campos reales.
        picker.value = '';

        files.forEach(function (file) {
          if (file.size > maxBytes) {
            alert('Una de las imágenes es muy grande. El límite es 10 MB por foto.');
            return;
          }
          var emptyIndex = firstEmptySlotIndex();
          if (emptyIndex === -1) return; // ya se llenaron las 2 fotos
          setSlotFile(emptyIndex, file);
        });
      });

      slots.forEach(function (slot, index) {
        var removeBtn = slot.querySelector('[data-pet-photo-remove]');
        if (removeBtn) {
          removeBtn.addEventListener('click', function () {
            setSlotFile(index, null);
          });
        }
      });

      refreshDropzoneVisibility();
    });
  }

  // ------------------------------------------------------------------
  // "¿Cómo prefieres que te contactemos?": al elegir Instagram / WhatsApp /
  // Correo, se revela (y se vuelve obligatorio) el campo de texto para
  // capturar el dato, con una etiqueta que cambia según lo elegido.
  // ------------------------------------------------------------------
  function setupContactMethod(wrapper) {
    var containers = wrapper.querySelectorAll('[data-contact-method]');
    containers.forEach(function (container) {
      var select = container.querySelector('[data-contact-select]');
      var detail = container.querySelector('[data-contact-detail]');
      var detailLabel = container.querySelector('[data-contact-detail-label]');
      var detailLabelText = container.querySelector('[data-contact-detail-label-text]');
      if (!select || !detail) return;

      var fieldLabels = {};
      try {
        fieldLabels = JSON.parse(container.getAttribute('data-contact-field-labels') || '{}');
      } catch (e) {
        fieldLabels = {};
      }

      function update() {
        var val = select.value;
        if (val) {
          detail.hidden = false;
          detail.disabled = false;
          detail.required = true;
          if (detailLabel) {
            detailLabel.hidden = false;
            if (detailLabelText) {
              detailLabelText.textContent = fieldLabels[val] || 'Tu dato de contacto';
            }
          }
        } else {
          detail.hidden = true;
          detail.disabled = true;
          detail.required = false;
          detail.value = '';
          if (detailLabel) detailLabel.hidden = true;
        }
      }

      select.addEventListener('change', update);
      update();
    });
  }

  // ------------------------------------------------------------------
  // Checkboxes con foto condicional (ej. "¿Incluir a un humano?" → sube
  // su foto). La foto solo se pide, se habilita y se vuelve obligatoria
  // si la casilla está marcada.
  // ------------------------------------------------------------------
  function setupConditionalPhotoToggles(wrapper) {
    var checkboxes = wrapper.querySelectorAll('[data-toggles-photo]');
    checkboxes.forEach(function (checkbox) {
      var group = checkbox.closest('[data-option-group]');
      var block = group ? group.querySelector('[data-conditional-photo]') : null;
      if (!block) return;
      var input = block.querySelector('[data-conditional-photo-input]');

      function update() {
        var visible = checkbox.checked;
        block.hidden = !visible;
        if (input) {
          input.disabled = !visible;
          input.required = visible;
          if (!visible) input.value = '';
        }
      }

      checkbox.addEventListener('change', function () {
        update();
        updatePriceDisplay(wrapper);
      });
      update();

      if (input) {
        input.addEventListener('change', function () {
          var previewWrap = block.querySelector('[data-conditional-photo-preview]');
          var previewImg = block.querySelector('[data-conditional-photo-preview-img]');
          var file = input.files && input.files[0];
          if (!file) {
            if (previewWrap) previewWrap.hidden = true;
            return;
          }
          var maxBytes = 10 * 1024 * 1024;
          if (file.size > maxBytes) {
            alert('La imagen es muy grande. El límite es 10 MB.');
            input.value = '';
            if (previewWrap) previewWrap.hidden = true;
            return;
          }
          var reader = new FileReader();
          reader.onload = function (e) {
            if (previewImg) previewImg.src = e.target.result;
            if (previewWrap) previewWrap.hidden = false;
          };
          reader.readAsDataURL(file);
        });
      }
    });
  }

  // ------------------------------------------------------------------
  // Grupos condicionados a la selección de OTRO grupo (ej. "Escoge el
  // color de tu lomito" solo debe aparecer si en "Escoge tu diseño" se
  // eligió "Diseño 1"). El grupo objetivo trae data-show-if-group (la
  // etiqueta del grupo disparador) y data-show-if-value (el valor que
  // debe estar seleccionado para mostrarlo).
  // ------------------------------------------------------------------
  function setupConditionalGroups(wrapper) {
    var targets = wrapper.querySelectorAll('[data-show-if-group]');
    targets.forEach(function (target) {
      var triggerLabel = target.getAttribute('data-show-if-group');
      var expectedValue = target.getAttribute('data-show-if-value');
      var triggerGroup = null;
      wrapper.querySelectorAll('[data-group-label]').forEach(function (g) {
        if (g.getAttribute('data-group-label') === triggerLabel) triggerGroup = g;
      });
      if (!triggerGroup) return;

      var inputs = target.querySelectorAll('[data-option-input]');

      function currentValue() {
        var checked = triggerGroup.querySelector(
          'input[type="radio"]:checked, input[type="checkbox"]:checked'
        );
        if (checked) return checked.value;
        var select = triggerGroup.querySelector('select[data-option-input]');
        if (select) return select.value;
        return '';
      }

      function update() {
        var visible = currentValue() === expectedValue;
        target.hidden = !visible;
        inputs.forEach(function (input) {
          input.disabled = !visible;
          if (!visible) input.checked = false;
        });
      }

      triggerGroup.addEventListener('change', function () {
        update();
        updatePriceDisplay(wrapper);
      });
      update();
    });
  }

  // ------------------------------------------------------------------
  // Los botones de "pago rápido" de Shopify (el widget que aparece
  // debajo de "Agregar al carrito" — puede mostrarse como el ícono de
  // PayPal, Shop Pay, o el botón negro genérico "Comprar ahora", según
  // el navegador/sesión del cliente) NO pasan por nuestro handleSubmit
  // ni respetan el <form> real: arman su propia solicitud a checkout
  // leyendo los campos del formulario de forma genérica. Para un
  // <input type="file"> eso significa que, en vez del archivo, mandan
  // el texto interno que el navegador usa para ese campo (algo como
  // "C:\fakepath\nombre.jpg"), nunca la foto real — así fue como dos
  // pedidos llegaron con las fotos de las mascotas "vacías" (ver
  // README.md, sección "Botones de pago rápido y fotos").
  //
  // Si el producto pide alguna foto (mascota, foto condicional, grupo
  // de fotos, imagen general, etc.), ocultamos ese botón para dejar un
  // solo camino de compra — "Agregar al carrito" — que sí maneja las
  // fotos correctamente. El cliente sigue pudiendo pagar con PayPal,
  // Mercado Pago, tarjeta, etc. normalmente, solo que ya no puede
  // saltarse el formulario con el atajo de pago rápido.
  // ------------------------------------------------------------------
  function hideAcceleratedCheckoutIfFileUpload(wrapper) {
    var hasFileUpload = wrapper.querySelector(
      '[data-group-photo-input], [data-multi-photo-input], [data-pet-photo-real], [data-conditional-photo-input], [data-option-image]'
    );
    if (!hasFileUpload) return;

    var scope = wrapper.closest('product-info') || wrapper.closest('.shopify-section') || document;
    var paymentButtons = scope.querySelectorAll('[data-shopify="payment-button"]');
    paymentButtons.forEach(function (btn) {
      btn.style.display = 'none';
    });
  }

  // ------------------------------------------------------------------
  // Revisa todo el formulario de opciones y devuelve el primer campo
  // obligatorio sin llenar, o null si todo está completo. Se usa para
  // validar justo antes de enviar (por ejemplo, si el campo de "dato
  // de contacto" quedó vacío aunque esté oculto por el momento).
  // ------------------------------------------------------------------
  function getFirstInvalidRequiredField(scopeEl) {
    var checkedRadioNames = {};
    scopeEl.querySelectorAll('input[type="radio"]:not([disabled])').forEach(function (r) {
      if (r.checked) checkedRadioNames[r.name] = true;
    });

    var candidates = scopeEl.querySelectorAll('[required]:not([disabled])');
    for (var i = 0; i < candidates.length; i++) {
      var field = candidates[i];
      if (field.type === 'radio') {
        if (!checkedRadioNames[field.name]) return field;
        continue;
      }
      if (field.type === 'checkbox') {
        if (!field.checked) return field;
        continue;
      }
      if (field.type === 'file') {
        if (!field.files || field.files.length === 0) return field;
        continue;
      }
      if (field.value === undefined || field.value === null || String(field.value).trim() === '') {
        return field;
      }
    }
    return null;
  }

  function findForm(wrapper) {
    var direct = wrapper.closest('form[action^="/cart/add"]') || wrapper.closest('form');
    if (direct) return direct;

    // En algunos layouts de Dawn (los que usan <product-info> con la
    // sección "pegajosa"/sticky), el <form action="/cart/add"> real NO
    // es un ancestro de este wrapper: product-info y product-form son
    // HERMANOS dentro de la misma sección, cada uno con su propio
    // contenido. Sin este resguardo, wrapper.closest('form') no
    // encuentra nada y el producto termina sin ninguna validación ni
    // envío de nuestras propiedades (ver ensureFormAssociation()).
    var scope = wrapper.closest('product-info') || wrapper.closest('.shopify-section') || document;
    var forms = scope.querySelectorAll('form[action^="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('[type="submit"]')) return forms[i];
    }
    return forms.length ? forms[0] : null;
  }

  // ------------------------------------------------------------------
  // Cuando el wrapper de opciones no vive DENTRO del <form> real (ver
  // findForm arriba), el navegador no considera nuestros campos parte
  // de ese formulario: ni los valida como obligatorios, ni
  // new FormData(form) los incluye — así que las fotos, nombres,
  // mascotas y datos de contacto nunca llegaban al carrito, sin
  // importar qué tan bien funcionara nuestra validación en JS.
  //
  // La solución nativa de HTML para "este campo pertenece a ese
  // formulario aunque esté en otro lugar del DOM" es el atributo
  // form="id-del-formulario" (funciona en <input>, <select>,
  // <textarea>). Lo agregamos por código a cada campo con nombre del
  // wrapper, apenas encontramos el formulario real.
  // ------------------------------------------------------------------
  function ensureFormAssociation(wrapper, form) {
    // OJO: usamos getAttribute/setAttribute('id', ...) y NUNCA form.id.
    // Los <form> tienen un comportamiento especial en el DOM: si tienen
    // un campo con name="id" (como el input oculto del ID de variante
    // que Shopify siempre incluye), la propiedad form.id deja de
    // devolver el atributo id del formulario y en su lugar devuelve ESE
    // campo — form.id === <input name="id">, no el string del id. Usar
    // form.id aquí generaba un identificador roto y ningún campo
    // terminaba realmente asociado al formulario.
    var formId = form.getAttribute('id');
    if (!formId) {
      formId = 'CustomOptionsForm-' + Math.random().toString(36).slice(2);
      form.setAttribute('id', formId);
    }
    wrapper.querySelectorAll('[name]').forEach(function (field) {
      if (field.getAttribute('form') !== formId) {
        field.setAttribute('form', formId);
      }
    });
  }

  // ------------------------------------------------------------------
  // Mantiene sincronizado el atributo aria-disabled del botón "Agregar
  // al carrito" con el estado real de validación de nuestras opciones.
  //
  // Por qué hace falta: Dawn (el tema) tiene su PROPIO listener de
  // "submit" en el custom element <product-form>, registrado ANTES que
  // el nuestro (su constructor corre apenas se parsea el HTML). Cuando
  // se envía el formulario, los dos listeners se disparan — el de Dawn
  // primero — y hacer evt.preventDefault() en el nuestro no cancela al
  // de Dawn: para cuando nuestra validación corre y detecta un campo
  // obligatorio vacío, Dawn ya hizo su propio fetch a /cart/add.js y el
  // producto ya se agregó al carrito. Por eso era posible agregar al
  // carrito sin llenar campos marcados con *.
  //
  // La solución: el propio onSubmitHandler de Dawn revisa
  // `this.submitButton.getAttribute('aria-disabled') === 'true'` y no
  // hace nada si es así. Si mantenemos ese atributo sincronizado en
  // tiempo real con nuestra validación (cada vez que la clienta escribe,
  // cambia una opción o quita una foto), el propio código de Dawn se
  // detiene solo — sin depender de ganarle ninguna carrera de eventos.
  // ------------------------------------------------------------------
  function syncSubmitButtonState(wrapper, form) {
    if (!form) return;
    var submitBtn = form.querySelector('[type="submit"]');
    if (!submitBtn) return;
    if (getFirstInvalidRequiredField(wrapper)) {
      submitBtn.setAttribute('aria-disabled', 'true');
    } else {
      submitBtn.removeAttribute('aria-disabled');
    }
  }

  function showError(form, message) {
    var errEl = form.querySelector('[data-custom-options-error]');
    if (!errEl) {
      errEl = document.createElement('div');
      errEl.setAttribute('data-custom-options-error', '');
      errEl.style.color = '#c0392b';
      errEl.style.marginTop = '8px';
      form.appendChild(errEl);
    }
    errEl.textContent = message;
  }

  function clearError(form) {
    var errEl = form.querySelector('[data-custom-options-error]');
    if (errEl) errEl.textContent = '';
  }

  async function handleSubmit(evt, wrapper, form) {
    evt.preventDefault();
    clearError(form);

    var invalidField = getFirstInvalidRequiredField(wrapper);
    if (invalidField) {
      var blockedBtn = form.querySelector('[type="submit"]');
      if (blockedBtn) blockedBtn.setAttribute('aria-disabled', 'true');
      if (typeof invalidField.scrollIntoView === 'function') {
        invalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      invalidField.focus();
      if (typeof invalidField.reportValidity === 'function') {
        invalidField.reportValidity();
      }
      showError(form, 'Por favor completa todas las opciones obligatorias antes de continuar.');
      return;
    }

    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute('data-original-text', submitBtn.textContent);
      submitBtn.textContent = 'Agregando...';
    }

    try {
      var surcharge = getTotalSurcharge(wrapper);
      var addonVariantId = null;

      if (surcharge > 0) {
        addonVariantId = ADDON_VARIANT_MAP[surcharge];
        if (!addonVariantId) {
          console.error(
            '[custom-options] No hay un ID de variante configurado en ADDON_VARIANT_MAP para el monto: ' +
              surcharge +
              '. Revisa custom-product-options.js.'
          );
          showError(
            form,
            'No se pudo calcular el recargo de esta opción. Por favor contacta a la tienda antes de continuar.'
          );
          resetSubmitButton(submitBtn);
          return;
        }
      }

      // 1) Agregar el producto principal (incluye la imagen y, si aplica,
      //    las fotos/nombres de cada bloque de mascota visible — los
      //    campos deshabilitados de bloques ocultos se excluyen solos
      //    del FormData).
      var formData = new FormData(form);
      // Identificador para vincular las dos líneas del carrito en el pedido
      var groupId = 'opt-' + Date.now() + '-' + Math.floor(Math.random() * 10000);
      formData.append('properties[_grupo_personalizacion]', groupId);

      // Propiedad explícita con la cantidad de mascotas, para que se vea
      // de un vistazo en el carrito y en el checkout (además de los
      // nombres/fotos de cada mascota que ya se incluyen arriba).
      var petQtyGroup = wrapper.querySelector('[data-pet-quantity]');
      if (petQtyGroup) {
        var petQtySelect = petQtyGroup.querySelector('[data-pet-qty-select]');
        var petQtyValue = petQtySelect ? petQtySelect.value : '1';
        formData.append('properties[Cantidad de mascotas]', petQtyValue);
      }

      var addRes = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      });

      if (!addRes.ok) {
        var errData = await addRes.json().catch(function () {
          return {};
        });
        throw new Error(errData.description || 'No se pudo agregar el producto al carrito.');
      }

      var addedItem = await addRes.json();

      // 2) Si hay recargo, agregar la segunda línea (producto de recargo).
      if (addonVariantId) {
        var addonRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: addonVariantId,
                quantity: form.querySelector('[name="quantity"]')
                  ? parseInt(form.querySelector('[name="quantity"]').value, 10) || 1
                  : 1,
                properties: {
                  _grupo_personalizacion: groupId,
                  _para_producto: addedItem.product_title || addedItem.title
                }
              }
            ]
          })
        });

        if (!addonRes.ok) {
          console.error('[custom-options] Error al agregar el cargo adicional al carrito.');
        }
      }

      // 3) Qué hacer después de agregar
      if (AFTER_ADD_BEHAVIOR === 'redirect') {
        window.location.href = '/cart';
      } else if (AFTER_ADD_BEHAVIOR === 'reload') {
        window.location.reload();
      } else {
        resetSubmitButton(submitBtn);
        document.dispatchEvent(new CustomEvent('custom-options:added', { detail: { groupId: groupId } }));
      }
    } catch (err) {
      console.error('[custom-options]', err);
      showError(form, 'Ocurrió un error al agregar el producto. Intenta de nuevo.');
      resetSubmitButton(submitBtn);
    }
  }

  function resetSubmitButton(submitBtn) {
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = submitBtn.getAttribute('data-original-text') || submitBtn.textContent;
    }
  }

  function initWrapper(wrapper) {
    updatePriceDisplay(wrapper);
    wrapper.querySelectorAll('[data-option-input]').forEach(function (input) {
      input.addEventListener('input', function () {
        updatePriceDisplay(wrapper);
      });
      input.addEventListener('change', function () {
        updatePriceDisplay(wrapper);
      });
    });

    setupImagePreview(wrapper);
    setupGroupPhotoUpload(wrapper);
    setupMultiPhotoUpload(wrapper);
    setupPetQuantity(wrapper);
    setupContactMethod(wrapper);
    setupConditionalPhotoToggles(wrapper);
    setupConditionalGroups(wrapper);
    hideAcceleratedCheckoutIfFileUpload(wrapper);
    updatePriceDisplay(wrapper);

    var form = findForm(wrapper);
    if (form) {
      ensureFormAssociation(wrapper, form);
    }
    if (form && !form.hasAttribute('data-custom-options-bound')) {
      form.setAttribute('data-custom-options-bound', 'true');
      form.addEventListener('submit', function (evt) {
        handleSubmit(evt, wrapper, form);
      });

      // Ver syncSubmitButtonState() más arriba: esto bloquea de verdad
      // el botón de Dawn (no solo lo marca con un asterisco) mientras
      // falte algún campo obligatorio.
      ['input', 'change', 'click'].forEach(function (eventName) {
        wrapper.addEventListener(eventName, function () {
          syncSubmitButtonState(wrapper, form);
        });
      });
      syncSubmitButtonState(wrapper, form);
    }
  }

  function init() {
    document.querySelectorAll('[data-custom-options]').forEach(initWrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Por si el tema vuelve a renderizar la sección (editor de temas)
  document.addEventListener('shopify:section:load', init);
})();

// ------------------------------------------------------------------
// Guía de razas por tamaño — Bowl Elevado Ergonómico (producto
// 10622167220511). Antes este marcado vivía en main-product.liquid /
// product-variant-picker.liquid; se movió aquí (se inyecta por
// JavaScript) para poder ajustarlo sin volver a tocar esos dos
// archivos grandes. Inserta una tarjetita justo después del selector
// de "Tamaño" (antes de "Color") con las razas recomendadas para el
// tamaño elegido, y se mantiene sincronizada aunque Shopify vuelva a
// renderizar el selector de variantes al cambiar de opción — el
// <product-info> que la contiene es un elemento estable que persiste
// entre esos re-renders (verificado en vivo), así que un
// MutationObserver sobre él basta para reinsertar y resincronizar la
// tarjeta cada vez que su contenido se reemplaza.
// ------------------------------------------------------------------
(function () {
  'use strict';

  var BOWL_PRODUCT_ID = '10622167220511';
  var BREED_GUIDE = {
    'CH (9cm de alto)':
      'Ideal para razas toy/miniatura: Chihuahua, Yorkshire Terrier, Pomerania, Poodle Toy, Shih Tzu.',
    'M (12cm de alto)':
      'Ideal para razas pequeñas: French Poodle, Pug, Salchicha (Dachshund), Shih Tzu adulto, Cocker Spaniel joven.',
    'L (15cm de alto)':
      'Ideal para razas medianas: Beagle, Cocker Spaniel, Bulldog Inglés, Border Collie, Schnauzer Mediano.',
    'XL (24 cm de alto)':
      'Ideal para razas grandes: Labrador, Golden Retriever, Pastor Alemán, Doberman, Boxer, Gran Danés.'
  };

  function findTamanoContainer(productInfo) {
    var candidates = productInfo.querySelectorAll('fieldset.product-form__input, .product-form__input--dropdown');
    for (var i = 0; i < candidates.length; i++) {
      var label = candidates[i].querySelector('legend, label');
      if (label && label.textContent.trim().indexOf('Tamaño') === 0) {
        return candidates[i];
      }
    }
    return null;
  }

  function buildCard() {
    var card = document.createElement('div');
    card.className = 'bowl-breed-guide';
    card.setAttribute('data-bowl-breed-guide', '');
    card.style.cssText =
      'margin: 0.6rem 0 1.15rem; padding: 0.8rem 1rem; background: #FBEEF3; border: 1px solid #F1D2E1; border-radius: 12px; display: flex; align-items: flex-start; gap: 0.6rem; font-size: 0.9rem; line-height: 1.45; color: #4a2f3a;';

    var paw = document.createElement('span');
    paw.setAttribute('aria-hidden', 'true');
    paw.style.cssText = 'font-size: 1.25rem; line-height: 1.2;';
    paw.textContent = '🐾';

    var textWrap = document.createElement('span');
    var label = document.createElement('strong');
    label.style.cssText = 'display: block; margin-bottom: 2px; font-size: 0.95rem;';
    label.textContent = 'Ideal para:';
    var textEl = document.createElement('span');
    textEl.setAttribute('data-bowl-breed-guide-text', '');
    textWrap.appendChild(label);
    textWrap.appendChild(textEl);

    card.appendChild(paw);
    card.appendChild(textWrap);
    return card;
  }

  // ------------------------------------------------------------------
  // Algunos temas/borradores todavía traen una versión antigua y sin
  // estilo de esta tarjeta, generada directamente en Liquid (antes de
  // que este marcado se moviera a JavaScript). Si la encontramos, la
  // "adoptamos": le aplicamos el estilo y la estructura completos en
  // vez de crear una tarjeta nueva por separado, para no terminar con
  // dos tarjetas ni dejar la vieja con su apariencia plana.
  // ------------------------------------------------------------------
  function upgradeCard(existing) {
    if (existing.dataset.bowlBreedGuideUpgraded === 'true') return existing;
    existing.dataset.bowlBreedGuideUpgraded = 'true';
    existing.className = 'bowl-breed-guide';
    existing.removeAttribute('data-bowl-breed-guide-ready');
    existing.style.cssText =
      'margin: 0.6rem 0 1.15rem; padding: 0.8rem 1rem; background: #FBEEF3; border: 1px solid #F1D2E1; border-radius: 12px; display: flex; align-items: flex-start; gap: 0.6rem; font-size: 0.9rem; line-height: 1.45; color: #4a2f3a;';
    existing.innerHTML = '';

    var paw = document.createElement('span');
    paw.setAttribute('aria-hidden', 'true');
    paw.style.cssText = 'font-size: 1.25rem; line-height: 1.2;';
    paw.textContent = '🐾';

    var textWrap = document.createElement('span');
    var label = document.createElement('strong');
    label.style.cssText = 'display: block; margin-bottom: 2px; font-size: 0.95rem;';
    label.textContent = 'Ideal para:';
    var textEl = document.createElement('span');
    textEl.setAttribute('data-bowl-breed-guide-text', '');
    textWrap.appendChild(label);
    textWrap.appendChild(textEl);

    existing.appendChild(paw);
    existing.appendChild(textWrap);
    return existing;
  }

  function ensureCard(productInfo) {
    var container = findTamanoContainer(productInfo);
    var existing = productInfo.querySelector('[data-bowl-breed-guide]');

    if (existing) {
      upgradeCard(existing);
      // La versión vieja en Liquid vivía en otro lugar del bloque de
      // producto (después de TODO el selector de variantes, no solo
      // después de "Tamaño"), así que aunque le arreglemos el estilo
      // en upgradeCard(), puede seguir apareciendo abajo de "Color" en
      // vez de arriba. La reubicamos aquí para que quede exactamente
      // donde debe: justo después de "Tamaño" y antes de "Color". El
      // chequeo de previousElementSibling evita moverla de nuevo en
      // cada re-sincronización si ya está en el lugar correcto.
      if (container && existing.previousElementSibling !== container) {
        container.insertAdjacentElement('afterend', existing);
      }
      return existing;
    }

    if (!container) return null;
    var card = buildCard();
    container.insertAdjacentElement('afterend', card);
    return card;
  }

  function syncFromChecked(productInfo) {
    var card = ensureCard(productInfo);
    if (!card) return;
    var checkedInput = productInfo.querySelector('input[name^="Tamaño-"]:checked');
    var textEl = card.querySelector('[data-bowl-breed-guide-text]');
    if (!checkedInput || !textEl) return;
    var value = checkedInput.value;
    if (Object.prototype.hasOwnProperty.call(BREED_GUIDE, value)) {
      var desired = BREED_GUIDE[value];
      if (textEl.textContent !== desired) {
        textEl.textContent = desired;
      }
    }
  }

  function initBowlBreedGuide() {
    var productInfo = document.querySelector('product-info[data-product-id="' + BOWL_PRODUCT_ID + '"]');
    if (!productInfo || productInfo.dataset.bowlBreedGuideBound) return;
    productInfo.dataset.bowlBreedGuideBound = 'true';

    syncFromChecked(productInfo);

    productInfo.addEventListener('change', function (event) {
      var target = event.target;
      if (target && target.matches && target.matches('input[name^="Tamaño-"]')) {
        syncFromChecked(productInfo);
      }
    });

    var observer = new MutationObserver(function () {
      syncFromChecked(productInfo);
    });
    observer.observe(productInfo, { childList: true, subtree: true });
  }

  function init() {
    if (document.querySelector('product-info[data-product-id="' + BOWL_PRODUCT_ID + '"]')) {
      initBowlBreedGuide();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
